module.exports = __webpack_public_path__ + "static/media/NegFeelingsRatedList.dc56aae7.csv";